module.exports = __webpack_public_path__ + "static/media/github-sign.78bb41d1.svg";